import styled from "styled-components";
import { MenuItem, Drawer, Menu } from "@mui/material";

const MenuDrawer = styled(Drawer)({
  flexShrink: 0,
  zIndex: 99999999,
  "& .MuiDrawer-paper": {
    width: "100%",
    height: "100%",
    boxSizing: "border-box",
    backgroundColor: (props) => props.theme.color.background.secondary,
  },
});

const Logo = styled.img`
  padding: 16px;
`;

const Spacer = styled.div`
  width: auto;
  margin-left: 16px;
  margin-right: 16px;
  border-top: 1px solid #7f7f86;
  opacity: 12%;
`;

const DrawerHeader = styled.div`
  display: flex;
  align-items: center;
  padding-right: 8px;
  background-color: ${(props) => props.theme.color.background.primary};
  justify-content: space-between;
`;

const ExploreMenuItem = styled(MenuItem)`
  margin-right: 24px;
  &.MuiMenuItem-root {
    color: ${(props) => props.theme.color.text.primary};
    font-family: ${(props) => props.theme.font.family};
    font-size: ${(props) => props.theme.font.size.disclaimer};
    font-weight: 600;
  }
`;

const ImageButton = styled.div`
  height: 24px;
  width: 24px;
  padding: 4px;
  margin-right: 24px;
  margin-top: 12px;
  margin-bottom: 12px;
  border-radius: 20%;
  background: ${(props) => props.$background} url(${(props) => props.$image}) no-repeat center/80%;
`;

const BackgroundButton = styled.div`
  font-weight: 600;
  font-size: ${(props) => props.theme.font.size.secondary};
  height: auto;
  text-overflow: ellipsis;
  max-lines: 1;
  padding: 8px 20px;
  text-align: center;
  text-decoration: none;
  margin: 16px 16px;
  border: none;
  display: inline-block;
  color: ${(props) => props.theme.color.text.secondary};
  background-color: ${(props) => props.theme.color.accent};
  border-radius: 4px;
  cursor: pointer;
`;

const AccountButtonContainer = styled.div`
  width: auto;
  display: flex;
  background-color: ${(props) => props.theme.color.background.secondary};
  margin: 16px;
  flex-direction: row;
  justify-content: end;
  padding: 8px 16px 8px 16px;
  border-radius: 5px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  cursor: pointer;
`;

const AccountAddressButton = styled.span`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  display: inline-block;
  align-items: center;
  font-weight: 600;
  font-size: ${(props) => props.theme.font.size.disclaimer};
  margin-right: 20px;
  color: ${(props) => props.theme.color.text.primary};
`;

const AccountCopyButton = styled.img`
  position: absolute;
  margin-left: 8px;
`;

const AccountMenuItem = styled(MenuItem)({
  color: (props) => props.theme.color.text.primary,
  fontSize: 14,
  fontWeight: 600,
});

const PopoverMenu = styled(Menu)`
  .MuiPaper-root {
    border-radius: 12px;
    color: ${(props) => props.theme.color.text.primary};
    background-color: ${(props) => props.theme.color.background.primary};
  }
`;

export {
  MenuDrawer,
  Logo,
  DrawerHeader,
  ExploreMenuItem,
  ImageButton,
  BackgroundButton,
  Spacer,
  AccountButtonContainer,
  AccountAddressButton,
  AccountCopyButton,
  AccountMenuItem,
  PopoverMenu,
};
